import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ThankYouPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50 w-full">
      <motion.div
        className="text-center p-8 bg-white rounded-xl shadow-lg"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-bold text-green-600 mb-4">Thank You!</h1>
        <p className="text-gray-700 mb-6">
          Your message has been received. We will get back to you soon.
        </p>
        <Link
          to="https://muskowl.com"
          className="text-white bg-green-500 px-4 py-2 rounded hover:bg-green-600 transition"
        >
          Back to Home
        </Link>
      </motion.div>
    </div>
  );
};

export default ThankYouPage;
